export default __webpack_public_path__ + "static/media/accusoft.4c30576d.png";